import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
	selector: "ui-circle-figure",
	templateUrl: "./circle.component.html",
	styleUrls: ["./circle.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CircleFigureComponent {
	@Input() size = "75px";
	@Input() background = "#22b89a";
}
